import { FunctionComponent } from "react";

import { Modal } from "@/components";

/**
 * The Archive ("Ignore Lead") and Done confirmation dialogs for the single
 * inbox lead. Extracted from {@link Inbox} to keep that page under the
 * file-length gate; each dialog is driven by its own show/save props.
 */
export const InboxConfirmModals: FunctionComponent<{
	showArchive: boolean;
	showDone: boolean;
	isLoading: boolean;
	onCloseArchive: () => void;
	onConfirmArchive: () => void;
	onCloseDone: () => void;
	onConfirmDone: () => void;
}> = ({
	showArchive,
	showDone,
	isLoading,
	onCloseArchive,
	onConfirmArchive,
	onCloseDone,
	onConfirmDone,
}) => {
	return (
		<>
			{showArchive && (
				<Modal
					handleClose={onCloseArchive}
					handleSave={onConfirmArchive}
					isLoading={isLoading}
					isOpened={showArchive}
					size="xs"
					submitButtonText="Archive"
					title="Ignore Lead"
				>
					<div className="flex flex-col gap-4">
						<div className="flex flex-col gap-2">
							<div className="flex flex-col gap-2">
								Are you sure you want to archive this prospect?
							</div>
						</div>
					</div>
				</Modal>
			)}
			{showDone && (
				<Modal
					handleClose={onCloseDone}
					handleSave={onConfirmDone}
					isLoading={isLoading}
					isOpened={showDone}
					size="xs"
					submitButtonText="Done"
					title="Mark as done"
				>
					<div className="flex flex-col gap-4">
						<div className="flex flex-col gap-2">
							<div className="flex flex-col gap-2">
								Are you sure you want to mark this conversation as completed?
							</div>
						</div>
					</div>
				</Modal>
			)}
		</>
	);
};
